export default function () {
  return {
    countriesAgreements: [],
    countriesGroupAgreements: [],
  };
}
